/* =====================================================================
   SIVEIA JEWELRY — GLOBAL INTERACTIONS
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.SiveiaTheme || {};
  var routes = theme.routes || {};

  $$('select[data-default]').forEach(function (select) {
    if (select.dataset.default) select.value = select.dataset.default;
  });

  /* ---------- Header scroll shadow ---------- */
  var header = $('#SiteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Mobile Nav Drawer ---------- */
  var mobileNav = $('#MobileNav');
  var mobileToggle = $('#MobileMenuToggle');
  var mobileClose = $('#MobileNavClose');
  var mobileOverlay = $('#MobileNavOverlay');
  function openMobileNav() { mobileNav && mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMobileNav() { mobileNav && mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
  mobileToggle && mobileToggle.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  /* ---------- Search overlay toggle ---------- */
  var searchToggle = $('#SearchToggle');
  var searchOverlay = $('#SearchOverlay');
  searchToggle && searchToggle.addEventListener('click', function () {
    if (!searchOverlay) return;
    var isOpen = searchOverlay.style.display === 'block';
    searchOverlay.style.display = isOpen ? 'none' : 'block';
  });

  /* ---------- Cart Drawer ---------- */
  var cartDrawer = $('#CartDrawer');
  var cartToggle = $('#CartToggle');
  var cartClose = $('#CartDrawerClose');
  var cartOverlay = $('#CartDrawerOverlay');
  function openCartDrawer() { cartDrawer && cartDrawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCartDrawer() { cartDrawer && cartDrawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  cartToggle && cartToggle.addEventListener('click', openCartDrawer);
  cartClose && cartClose.addEventListener('click', closeCartDrawer);
  cartOverlay && cartOverlay.addEventListener('click', closeCartDrawer);
  window.SiveiaOpenCart = openCartDrawer;

  /* ---------- Filter Drawer (collection page) ---------- */
  var filterDrawer = $('#FilterDrawer');
  var filterToggle = $('#FilterToggle');
  var filterClose = $('#FilterDrawerClose');
  var filterOverlay = $('#FilterDrawerOverlay');
  filterToggle && filterToggle.addEventListener('click', function () { filterDrawer && filterDrawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  filterClose && filterClose.addEventListener('click', function () { filterDrawer && filterDrawer.classList.remove('is-open'); document.body.style.overflow = ''; });
  filterOverlay && filterOverlay.addEventListener('click', function () { filterDrawer && filterDrawer.classList.remove('is-open'); document.body.style.overflow = ''; });

  /* ---------- Quantity Selectors (generic, quantity input in same container) ---------- */
  $$('.qty-selector').forEach(function (box) {
    var input = box.querySelector('input');
    var minus = box.querySelector('.js-qty-minus');
    var plus = box.querySelector('.js-qty-plus');
    if (!input) return;
    if ((minus && minus.dataset.line) || (plus && plus.dataset.line)) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Accordion (product page) ---------- */
  $$('.js-accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion-item');
      var content = item.querySelector('.accordion-item__content');
      var isOpen = item.classList.contains('is-open');
      // close others
      $$('.accordion-item').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('.accordion-item__content').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Product Gallery Thumbnails ---------- */
  var mainImg = $('#MainProductImage');
  $$('.js-gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      $$('.js-gallery-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- Variant Swatches (product page) ---------- */
  var variantData = window.__PRODUCT_VARIANTS__ || [];
  var selectedOptions = {};
  var initiallySelected = variantData.find(function (variant) {
    var select = $('#ProductSelectVariant');
    return select && String(variant.id) === select.value;
  });
  if (initiallySelected && initiallySelected.options) {
    initiallySelected.options.forEach(function (value, index) { selectedOptions[index] = value; });
  }

  $$('.js-variant-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var idx = swatch.dataset.optionIndex;
      var group = swatch.closest('.variant-group');
      $$('.js-variant-swatch', group).forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');
      var labelSpan = group.querySelector('.js-selected-value');
      if (labelSpan) labelSpan.textContent = swatch.dataset.value;
      selectedOptions[idx] = swatch.dataset.value;
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    if (!variantData.length) return;
    var match = variantData.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return Object.keys(selectedOptions).every(function (idx) {
        return opts[idx] === selectedOptions[idx];
      });
    });
    var select = $('#ProductSelectVariant');
    var priceEl = $('#ProductPrice');
    var addBtn = $('#AddToCartBtn');
    if (match) {
      if (select) select.value = match.id;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<span class="price--compare">' + formatMoney(match.compare_at_price) + '</span><span class="price--sale">' + formatMoney(match.price) + '</span>'
          : '<span>' + formatMoney(match.price) + '</span>';
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
      }
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src;
        mainImg.alt = match.featured_image.alt || mainImg.alt;
      }
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(theme.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency: theme.currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + (theme.currency || 'USD');
    }
  }

  /* ---------- AJAX Add to Cart (progressive enhancement) ---------- */
  var productForm = $('#ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var btn = $('#AddToCartBtn');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      fetch(routes.cartAdd || '/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || 'Unable to add this item');
            return data;
          });
        })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () {
            window.location.href = (routes.cart || '/cart.js').replace(/\.js$/, '');
          }, 350);
        })
        .catch(function (error) {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          alert(error.message || 'Failed to add. Please try again.');
        });
    });
  }

  function updateCartCount() {
    fetch(routes.cart || '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var el = $('#CartCount');
      if (el) el.textContent = cart.item_count;
    });
  }

  /* ---------- Cart quantity updates ---------- */
  $$('.js-cart-qty-minus, .js-cart-qty-plus, .cart-drawer .js-qty-minus, .cart-drawer .js-qty-plus').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = button.parentElement.querySelector('input');
      var line = Number(button.dataset.line);
      var delta = button.classList.contains('js-cart-qty-minus') || button.classList.contains('js-qty-minus') ? -1 : 1;
      var quantity = Math.max(0, Number(input && input.value || 1) + delta);
      button.disabled = true;
      fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      }).catch(function () {
        button.disabled = false;
        alert('Unable to update the bag. Please try again.');
      });
    });
  });

  /* ---------- Quick Add from Product Card ---------- */
  $$('.js-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Simple approach: navigate to product page for full variant selection
      window.location.href = btn.dataset.productUrl;
    });
  });

  /* ---------- Scroll Reveal ---------- */
  var revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Escape key closes all overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCartDrawer();
      filterDrawer && filterDrawer.classList.remove('is-open');
      if (searchOverlay) searchOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

})();
